import { listTileReducerFactory } from '../../../pillar/dashboard/store/reducers/list-tile.reducerFactory';
import { TileState } from '../../../pillar/dashboard/store/state/TileState';
import * as workspaceActions from '../../../pillar/workspace/store/actions';
import { ModuleConfiguration } from '../../dynamicDataSet.module.config';
import { DynamicDataSetListModel } from '../../models/DynamicDataSetListModel';
import { DynamicDataSetModel } from '../../models/DynamicDataSetModel';
import { FINALIZE_DYNAMICDATASET_SUCCESS, FinalizeDynamicDataSetSuccessAction } from '../actions/FinalizeDynamicDataSetSuccessAction';
import { FINALIZE_DYNAMICDATASET } from '../actions/FinalizeDynamicDataSetAction';
import { CREATEDRAFT_DYNAMICDATASET } from '../actions/CreateDraftDynamicAction';
import { CREATEDRAFT_DYNAMICDATASET_SUCCESS, CreateDraftDynamicDataSetSuccessAction } from '../actions/CreateDraftDynamicSuccessAction';
import { UNFINALIZE_DYNAMICDATASET } from '../actions/UnfinalizeDynamicDataSet';
import { UNFINALIZE_DYNAMICDATASET_SUCCESS, UnfinalizeDynamicDataSetSuccessAction } from '../actions/UnfinalizeDynamicDataSetSuccessAction';
import * as actions from '../../../pillar/dashboard/store/actions/';

let stateReducer;
export function stateReducerWrapper (state = new TileState<DynamicDataSetListModel, DynamicDataSetModel>(), action: actions.Actions<any>): TileState<any, any>  {
  if(!stateReducer){
    stateReducer = listTileReducerFactory(ModuleConfiguration.moduleName, DynamicDataSetListModel, DynamicDataSetModel, new TileState<DynamicDataSetListModel, DynamicDataSetModel>());
  }
  return stateReducer(state, action);
}

export function DynamicDataSetReducer(state = new TileState<DynamicDataSetListModel, DynamicDataSetModel>(), action: workspaceActions.Actions<DynamicDataSetModel, any> | FinalizeDynamicDataSetSuccessAction | CreateDraftDynamicDataSetSuccessAction | UnfinalizeDynamicDataSetSuccessAction): TileState<DynamicDataSetListModel, DynamicDataSetModel> {
  switch (action.type) {
    case FINALIZE_DYNAMICDATASET:
      return {
        ...state,
        loading: true
      }
    case FINALIZE_DYNAMICDATASET_SUCCESS:
      var finalizeAction = action as FinalizeDynamicDataSetSuccessAction;
      return {
        ...state,
        selected: finalizeAction.payload.dynamicDataSet,
        loading: false
      }
    case UNFINALIZE_DYNAMICDATASET:
      return {
        ...state,
        loading: true
      }
    case UNFINALIZE_DYNAMICDATASET_SUCCESS:
      var unfinalizeAction = action as UnfinalizeDynamicDataSetSuccessAction;
      return {
        ...state,
        selected: unfinalizeAction.payload.dynamicDataSet,
        loading: false
      }
    case CREATEDRAFT_DYNAMICDATASET:
      return {
        ...state,
        loading: true
      }
    case CREATEDRAFT_DYNAMICDATASET_SUCCESS:
      var createDraftAction = action as CreateDraftDynamicDataSetSuccessAction;
      return {
        ...state,
        selected: createDraftAction.payload.dynamicDataSet,
        loading: false
      }
    default:
      return stateReducerWrapper(state, action);
  }
}



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/store/reducers/dynamicDataSet.reducer.ts